import React, { useEffect, useState } from 'react'
import './timepicker.scss'
import { Form, TimePicker } from 'antd'
import dayjs from 'dayjs'
import CustomTimeRangePicker from './CustomTimeRangePicker'
const TimeSelector = ({
  initialValue,
  label,
  controlName,
  validators,
  avalialbleHours,
  onTimeChange,
  allTimeSelector
}: any) => {
  const format = 'h:mm A'
  // const onChange = (time: any, timeString: any) => {
  // console.log('yo', label, controlName, initialValue);
  //     registrationForm.setFieldValue(controlName, timeString)
  // };

  const onChange = (time: any, setAll: boolean) => {
    console.log(time)
    if (avalialbleHours && avalialbleHours[controlName] && setAll) {
      // Ensure both open and close times are selected
      if (time && time[0] && time[1]) {
        const open = dayjs(time[0]).format('hh:mm A')
        const close = dayjs(time[1]).format('hh:mm A')
        avalialbleHours[controlName].workingHours.open = open
        avalialbleHours[controlName].workingHours.close = close
        onTimeChange(avalialbleHours[controlName])
      }
      // Optionally, you can return here to avoid calling onTimeChange(time) below
      return
    }
    onTimeChange(time)
  }

  return (
    <>
      <Form.Item
        initialValue={
          Array.isArray(initialValue) && initialValue[0] !== ''
            ? [dayjs(initialValue[0], format), dayjs(initialValue[1], format)]
            : ''
        }
        label={label}
        style={{ fontSize: 20 }}
        name={controlName}
        rules={validators}
      >
        {/* {allTimeSelector ? <TimePicker.RangePicker style={{ flex: 'none' }} use12Hours format={format} onChange={(e) => onChange(e, true)} />
                : <TimePicker.RangePicker style={{ flex: 'none' }} use12Hours format={format} onChange={(e) => onChange(e, false)} />
            } */}
        {allTimeSelector ? (
          <CustomTimeRangePicker
            style={{ flex: 'none' }}
            use12Hours
            format={format}
            onChange={(e) => onChange(e, true)}
          />
        ) : (
          <CustomTimeRangePicker
            style={{ flex: 'none' }}
            use12Hours
            format={format}
            onChange={(e) => onChange(e, false)}
          />
        )}
      </Form.Item>
    </>
  )
}

export default TimeSelector
